import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Dropdown = ({ items }) => {
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);

  const toggleSubMenu = (index) => {
    setOpenSubMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <ul
      className="absolute top-full bg-white shadow-xl border border-[var(--brand-primary-100)] rounded-xl py-2 w-56 z-[200] text-sm max-h-[70vh] overflow-y-auto"
      style={{ scrollbarWidth: "thin", scrollbarColor: "var(--brand-primary-300) transparent" }}
    >
      {items.map((item, index) => (
        <li key={index} className="relative">
          <div
            className={`flex justify-between items-center px-4 py-2 cursor-pointer hover:bg-[var(--brand-primary-50)] hover:text-[var(--brand-primary-700)] transition-colors ${item.color || ""}`}
            onClick={() => item.subDropdown && toggleSubMenu(index)}
          >
            {item.path ? (
              <Link
                to={item.path}
                className="flex-1"
                onClick={() => window.scrollTo(0, 0)}
              >
                {item.label}
              </Link>
            ) : (
              // No path: the label only opens/closes its submenu
              <span className="flex-1 select-none">{item.label}</span>
            )}
            {item.subDropdown && (
              <span className="text-xs text-[var(--brand-primary-400)] ml-2">
                {openSubMenuIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            )}
          </div>
          {item.subDropdown && openSubMenuIndex === index && (
            <ul className="bg-[var(--brand-primary-50)]/50 py-1 w-full border-y border-[var(--brand-primary-100)]">
              {item.subDropdown.map((subItem, subIndex) => (
                <li key={subIndex}>
                  <Link
                    to={subItem.path || "/"}
                    className="block pl-8 pr-4 py-2 hover:bg-[var(--brand-primary-100)] hover:text-[var(--brand-primary-700)] transition-colors"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {subItem.label}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default Dropdown;
